"use client"

import { useState, useContext } from "react"
import axios from "axios"
import { Link, useNavigate } from "react-router-dom" // useNavigate ইম্পোর্ট করা হয়েছে
import { Box, TextField, Button, Typography, Paper, Alert } from "@mui/material" // Material UI কম্পোনেন্ট ইম্পোর্ট করা হয়েছে

import BaseURL from "../../api/AppURL";
import ProfileContext from "../../contexts/ProfileContext"; // ✅ যোগ করো
import { imgAdminBaseUrl, imgVendorBaseUrl } from "../../api/AppURL";


const Login = ({ onLogin }) => {
  const [email, setEmail] = useState("test@gmail.com")
  const [password, setPassword] = useState("password")
  const [error, setError] = useState("")
  const navigate = useNavigate() // useNavigate হুক ব্যবহার করা হয়েছে

  const { setProfile } = useContext(ProfileContext); // ✅ Context ব্যবহার

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await axios.post(`${BaseURL}/login`, {
        email: email,
        password: password,
      });

      // ✅ যদি লগইন সফল হয়
      if (response.data && response.data.token) {
        const user = response.data.user;
        const role = user.role
        const photoUrl =
          user.photo
            ? (role?.toLowerCase() === "vendor"
              ? `${imgVendorBaseUrl}${user.photo}`
              : `${imgAdminBaseUrl}${user.photo}`)
            : "/no_image.jpg";

        console.log(`admin= ${imgAdminBaseUrl}${user.photo}`);


        // টোকেন ও রোল সংরক্ষণ করো
        localStorage.setItem("auth_token", response.data.token);
        localStorage.setItem("user_role", user.role);

        // ✅ প্রোফাইল Context আপডেট করো (Header সাথে সাথে আপডেট হবে)
        setProfile({
          name: user.name || "User",
          email: user.email || "",
          photo: user.photo ? photoUrl : "",
        });

        // ✅ localStorage এ রাখো (রিফ্রেশ করলে থাকবে)
        localStorage.setItem(
          "profile",
          JSON.stringify({
            name: user.name || "User",
            email: user.email || "",
            photo: user.photo ? photoUrl : "",
          })
        );

        // App.js কে জানাও যে লগইন হয়েছে
        onLogin();

        // ✅ রোল অনুযায়ী redirect
        if (user.role === "vendor") {
          navigate("/amanager/dashboard");
        } else {
          navigate("/admin/dashboard");
        }
      } else {
        setError("Invalid credentials");
      }
    } catch (error) {
      if (error.response?.status === 403) {
        setError("Please verify your email before logging in.");
      } else {
        setError("Invalid credentials");
      }
    }
  };


  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
      }}
    >
      <Paper elevation={3} sx={{ p: 4, maxWidth: 400, width: "100%", borderRadius: 2 }}>
        <Typography variant="h5" component="h1" gutterBottom sx={{ mb: 3, textAlign: "center", fontWeight: "bold" }}>
          Login
        </Typography>
        <form onSubmit={handleLogin}>
          <TextField
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            margin="normal"
            variant="outlined"
            sx={{ mb: 2 }}
          />
          <TextField
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            margin="normal"
            variant="outlined"
            sx={{ mb: 3 }}
          />
          <Button type="submit" variant="contained" fullWidth sx={{ mb: 2, py: 1.5 }}>
            Login
          </Button>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap" }}>
            <Link to="/forgot-password" style={{ textDecoration: "none" }}>
              <Button variant="text" sx={{ textTransform: "none" }}>
                Forgot Password?
              </Button>
            </Link>
            <Link to="/register" style={{ textDecoration: "none" }}>
              <Button variant="outlined" sx={{ textTransform: "none" }}>
                Create New Account
              </Button>
            </Link>
          </Box>
          {error && (
            <Alert severity="error" sx={{ mt: 3 }}>
              {error}
            </Alert>
          )}
        </form>
      </Paper>
    </Box>
  )
}

export default Login
